import UUID from 'uuid'
import BaseEvent from './base/BaseEvent'
import Draw from './draw/Draw'
import MapContextMenu from './controls/MapContextMenu'
// import PosZoom from './controls/PosZoom'
import { isString } from 'util'
import { MiscUtil, deepCopy, mergeObjs } from './miscUtil'
import { LayerUtil } from './layerUtil'
import { FeatureUtil } from './featureUtil'
import Zoom from "./controls/Zoom";

// 地图相关方法
export const Map2DUtil = {
    /**
     * 创建一个地图
     * @param {String} div 地图容器
     * @param {Object} opt_options 可选参数，zoom，center
     * @return {GeoGlobe.Map} map 地图
     */
    async createMap(div, opt_options) {
        const simple = {
            version: 8,
            sources: {},
            layers: [],
            light: {
                "anchor": "viewport",
                "color": "#fff",
                "intensity": 0.4,
                "position": [1.5,
                    150, -50
                ]
            },
        }

        const { zoom = 15, lat = 0, lon = 0 } = opt_options || {}

        let config = global.CONFIG

        const map = new GeoGlobe.Map({
            // mapCRS: mapCRS, // 4490
            mapCRS: {//坐标参考
                topTileExtent: [-180, -270, 180, 90],
                "tileSize": 256,
                coordtransform: 'none',
                "units": "degrees"
            },
            container: div,
            zoom: config.centerConf.zoom,
            center: [config.centerConf.lon, config.centerConf.lat],
            maxZoom: 20, //最大缩放级别
            minZoom: 1, //最小缩放级别
            showLogo: false,//logo是否显示

        })

        return new Promise((resolve, reject) => {
            try {
                map.once('style.load', () => {
                    resolve(map)
                })
            } catch (error) {
                reject(error)
            }
        })
    },

    /**
     * 初始化控件
     * @param {Object} map 地图对象
     */
    initControls(map) {

        // let abs = document.getElementsByClassName('abs')[0]
        // let zoom_control = document.createElement('div')
        // zoom_control.className = 'mapboxgl-ctrl-zoom myZoom'
        // zoom_control.innerHTML = global.CONFIG.centerConf.zoom
        // abs.appendChild(zoom_control)



        // 比例尺控件
        /*const Sca_control = new GeoGlobe.Control.Scale({
            position: 'bottom-left',
            maxWidth: 80,
            unit: 'm'
        })
        map.addControl(Sca_control, Sca_control.options.position)*/

        // 缩放比例
        // const posZoom = new PosZoom()
        // map.addControl(posZoom, 'bottom-left')

        // 导航控件
        const Na_control = new GeoGlobe.Control.Navigation()
        map.addControl(Na_control, 'bottom-right')
        // 缩放层级
        const Zoom_control = new Zoom()
        map.addControl(Zoom_control, 'bottom-right')
        // const ScaControl = new GeoGlobe.Control.Scale({
        //     position: 'bottom-left',
        //     maxWidth: 80,
        //     unit: 'm',
        // });

        // var ScaControl = new mapboxgl.ScaleControl({
        //     maxWidth: 80,
        //     unit: 'm'
        // });
        // map.addControl(ScaControl, ScaControl.options.position);

    },

    /**
     * 初始化右键菜单
     * @param {GeoGlobe.Map} map
     */
    initRightMenu(map) {
        const cm = new MapContextMenu()
        map.addControl(cm)
        return cm
    }
}

/**
 * 基础地图操作类
 */
export class BaseMap2DView extends BaseEvent {
    /**
     * 初始化MapView
     * @param {mapbox.gl.Map} map map对象
     * @param {Array.<String>} groups 分组对象
     */
    constructor(map, groups = []) {
        super()
        this._map = map
        this._init(map, groups)

        // 图层组
        this._groups = groups
        // 底图图层（默认图层）
        this._bottomGroup = [...groups].shift()
        // 默认图层（通过addLayer方法的添加的图层，如果没有默认图层都属于该图层）
        this._topGroup = [...groups].pop()

        // 绘画对象
        this._draws = new Map()
    }

    /**
     * 原始地图对象
     */
    get map() {
        return this._map
    }

    /**
     * 中心点和缩放
     */
    get centerZoom() {
        const center = this._map.getCenter().toArray()
        const zoom = this._map.getZoom()
        return { center, zoom }
    }
    set centerZoom({ center, zoom }) {
        center && this._map.setCenter(center)
        zoom && this._map.setZoom(zoom)
    }

    /**
     * @private
     * 初始化图层组
     * @param {Array} groupIds
     */
    _createLGroups(map, groupIds) {
        const groups = groupIds.map(g => {
            return LayerUtil.createVectorLayer('point', {
                id: g,
                layout: { visibility: 'none' }
            })
        })
        // 基础图层，为了划分图层组顺序
        mapboxgl.LayerGroup.addGroup(map, UUID.v1(), groups)
    }

    /**
     * @private
     * 初始化
     * @param {*} map
     * @param {*} groups
     */
    _init(map, groups) {
        this._createLGroups(map, groups)

        const self = this
        // 重新getStyle
        map.getStyle = function() {
            const styles = this.__proto__.getStyle.call(this)
            return deepCopy(styles)
        }
        // 重写addLayer
        map.addLayer = function(layer, before) {
            let group = self._topGroup

            // 存在before(尝试设置为同一图层组)
            if (before) {
                if (self._groups.includes(before)) {
                    group = before
                }
            }

            // 图册组支持
            if (!layer.metadata || !layer.metadata.group) {
                // 添加group
                layer.metadata = mergeObjs({}, layer.metadata, { group })
            }

            // 不存在的时候添加到图层组第一个
            if (!before) {
                before = layer.metadata.group
            }

            // 触发图层修改事件
            self.fire('layer-change', layer)

            this.__proto__.addLayer.call(this, deepCopy(layer), before)
        }

        // 重写removeLayer
        map.removeLayer = function(layerId) {
            const layer = this.getLayer(layerId)

            // 触发图层修改事件
            if (layer && layer.metadata && layer.metadata.group) {
                self.fire('layer-change', layer)
            }

            // removeLayer
            this.__proto__.removeLayer.call(this, layerId)
        }

        // 添加layer到图层组
        map.addLayerToGroup = function(groupId, layer, before) {
            layer.metadata = mergeObjs({}, layer.metadata, { group: groupId })
            this.addLayer(layer, before)
        }

        // 重写fitBounds(保留部分边界)
        map.fitBounds = function(bounds, fitBoundsOptions, eventData) {
            bounds = mapboxgl.LngLatBounds.convert(bounds).toArray()
            const a = bounds[0].map(b => b * 0.9998)
            const b = bounds[1].map(b => b * 1.0002)

            this.__proto__.fitBounds.call(
                this,
                [a, b],
                fitBoundsOptions,
                eventData
            )
        }
    }

    addLayers2Group(layerArr, groupId, before) {
        groupId = groupId || this._bottomGroup;

        for (let i = 0; i < layerArr.length; i++) {
            const { type, data } = layerArr[i];

            // 常规图层
            if (['WMS', 'WMTS', 'VWMTS'].includes(type)) {
                const { layer, source } = data;

                this.map.addSource(source.id, source);
                this.map.addLayerToGroup(groupId, layer, before);
            }
            // 矢量图层
            if (['VTS', 'VVTS'].includes(type)) {
                const { layer, source } = data;

                if (layer.sprite != null && layer.sprite != '') {
                    console.log('加载注记sprite', layer.sprite)
                    this.map.loadSprite(layer.sprite);
                }
                if (layer.glyphs != null && layer.glyphs != '') {
                    console.log('加载注记glyphs', layer.glyphs)
                    this.map.setGlyphs(layer.glyphs);
                }

                // 存在字体库添加矢量图层
                if (this.map.style.glyphManager.url !== '') {
                    this.map.addSource(source.id, source);

                    for (const key in layer.layerData) {
                        this.map.addLayerToGroup(
                            groupId,
                            layer.layerData[key],
                            before
                        );
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.error('矢量图层加载：', '没有可用的字体服务！');
                }
            }
            // TILE
            if (['TILE'].includes(type)) {
                this.map.addLayerToGroup(groupId, data, before);
            }
        }
    }

    /**
     * @api
     * 清空指定图层组
     * @param {Sting} groupId
     */
    clearGroup(groupId) {
        groupId = groupId || this._bottomGroup

        const layerArr = mapboxgl.LayerGroup.getLayersfromGroup(
            this.map,
            groupId
        )
        for (let i = 0; i < layerArr.length; i++) {
            const { id } = layerArr[i]
            if (this.map.getLayer(id) != null) {
                this.map.removeLayer(id)
            }
        }
        for (let i = 0; i < layerArr.length; i++) {
            const { source } = layerArr[i]
            if (this.map.getSource(source) != null) {
                this.map.removeSource(source)
            }
        }
    }

    /**
     * @api
     * 从指定图层中获取指定类型图层
     * @param {*} groupId
     * @param {*} layerType
     */
    getLayersFromGroup(groupId, layerType) {
        groupId = groupId || this._bottomGroup

        // 获取图层组图层
        const layerArr = mapboxgl.LayerGroup.getLayersfromGroup(
            this.map,
            groupId
        )
        // 进行图层type筛选
        if (layerType) {
            if (isString(layerType)) {
                layerType = [layerType]
            }
            return layerArr.filter(l => {
                if (l.metadata && l.metadata.type) {
                    return (
                        layerType.includes(l.type) ||
                        layerType.includes(l.metadata.type)
                    )
                }
                return layerType.includes(l.type)
            })
        }

        // 返回
        return layerArr
    }

    /**
     * @api
     * 查找上面图层
     * @param {String} layerId
     */
    findBefore(layerId) {
        const oldLayers = this.map.getStyle().layers
        const layerIndex = oldLayers.findIndex(l => l.id === layerId)
        const before = oldLayers[layerIndex + 1] && oldLayers[layerIndex + 1].id
        return before
    }

    /**
     * @api
     * 重新加载图层source
     * @param {String} layerId 图层id
     * @param {*} source 新数据源
     * @param {*} sourceLayer 数据源的数据源
     */
    relaodLayerSource(layerId, source, sourceLayer) {
        const oldLayers = this.map.getStyle().layers
        const layerIndex = oldLayers.findIndex(l => l.id === layerId)
        const layerDef = oldLayers[layerIndex]
        const before = oldLayers[layerIndex + 1] && oldLayers[layerIndex + 1].id

        layerDef.source = source
        if (sourceLayer) {
            layerDef['source-layer'] = sourceLayer
        }
        this.map.removeLayer(layerId)
        this.map.addLayer(layerDef, before)
    }

    /**
     * @api
     * 根据source获取图层
     * @param {*} sourceId
     */
    getLayersBySource(sourceId) {
        const retLayers = []
        const oldLayers = [...this.map.getStyle().layers]
        oldLayers.forEach(l => {
            if (l.source === sourceId) {
                retLayers.push(l)
            }
        })
        return retLayers
    }

    /**
     * @api
     * 根据source删除图层和source
     * @param {*} sourceId
     */
    removeLayersBySource(sourceId, removeSource = true) {
        const oldLayers = [...this.map.getStyle().layers]
        oldLayers.forEach(l => {
            if (l.source === sourceId) {
                this.map.removeLayer(l.id)
            }
        })
        if (removeSource) {
            this.map.removeSource(sourceId)
        }
    }

    /**
     * @api
     * 获取绘制工具对象
     * @param {*} id
     * @param {*} param1
     */

    getDraw(id, styles) {
        if (this._draws.has(id)) {
            return this._draws.get(id)
        } else {
            const draw = new Draw(styles)
            draw.setMap(this.map)
            this._draws.set(id, draw)

            return draw
        }
    }

    /**
     * @api
     * 销毁绘制工具对象
     * @param {*} id
     */
    removeDraw(id) {
        if (this._draws.has(id)) {
            this._draws.get(id).setMap(null)
            this._draws.delete(id)
            return true
        }
        return false
    }

    /**
     * @api
     * 设置中心点
     * @param {*} feature
     */
    panTo(feature) {
        if (feature && feature.geometry) {
            const center = FeatureUtil.getCenter(feature)
            this.map.panTo(center)
        }
    }

    /**
     * @api
     * 移动到合适的位置
     * @param {*} feature
     */
    fitBounds(feature) {
        const bounds = FeatureUtil.getBounds(feature)
        bounds && this.map.fitBounds(bounds)
    }
}
